<icn-dropdown
  class="day-of-week-picker"
  [ngStyle]="overrideStyle"
  [(selectedValue)]="selectedDay"
  (selectedValueChange)="onChange.emit($event)"
>
  <icn-dropdown-item
    *ngFor="let day of dayOfWeeks"
    [title]="day.name"
    [value]="day.id"
  ></icn-dropdown-item>
</icn-dropdown>
